

import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import requestService from "@/service/requestService";
import Number from "@/shared/filters/Number";
import { Utils } from "@/service/util";
import { CouponData } from "@/model/Coupon";
import { Getter, Action } from "vuex-class";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { UserService } from "@/service/UserService";
import loadingService from "@/service/loadingService";
import { MESSAGE } from "@/model/Message";
import TopBarTitle from "@/components/common/TopBarTitle.vue";
import InputNumber from "@/components/common/input/InputNumber.vue";
import CouponPage from "@/page/user/CouponPage.vue";
@Component({
  filters: {
    Number
  },
  components: {
    ConfirmDialog,
    TopBarTitle,
    InputNumber
  }
})
export default class QuickCouponComponent extends CouponPage {
  isModeModal: boolean = true;
  isModeQuick: boolean = false;

/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [START] */
  @Prop() modeQuick: boolean;
  excludingFlg: boolean = false;
  excludingTex: string = "";
/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [END] */

  addClass: any = "top-bar__override";
  loadingService: loadingService = new loadingService();
  public utils: Utils = new Utils();

/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [START] */
  mounted() {
    this.$emit("onActiveSideTab", "discountcoupon");
    if (this.modeQuick) {
      this.excludingFlg = false;
      this.excludingTex = "税込";
      this.isModeQuick = this.modeQuick; // 一旦別フラグ扱いにする
    } else {
      if ( this.isExcludingTax ) { this.excludingFlg = true; }
      this.excludingTex = this.taxLabel;
      this.isModeQuick = this.modeQuick; // 一旦別フラグ扱いにする
    }
  }
/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [END] */

  onConfirm(isConfirm: number) {
    if (this.couponData) {
      if (this.couponData.coupon && this.couponData.coupon.items) {
        this.couponData.coupon.subTotalZk = this.subTotalZk;
        this.couponData.coupon.subTotalZn = this.subTotalZn;
      }
      this.setCoupon(this.couponData);
      let isConfirmCopied: any = isConfirm;
      if (isConfirm == 0) {
        isConfirmCopied = this.couponData.isConfirm;
      }
      if (
        this.couponDataForSave.coupon &&
        this.couponDataForSave.proposal &&
        this.couponDataForSave.tokuten
      ) {
        this.loadingService.show();
        this.reqService
          .saveCoupon({ // sendSocket:ソケット仮11
            coupons: this.couponDataForSave.coupon.items || [],
            proposals: this.couponDataForSave.proposal.items || [],
            tokutens: this.couponDataForSave.tokuten.items || [],
            sknUketsukeUserJouhou: {
              isConfirmCoupon: isConfirmCopied
            },
            sknUketsukeExtendsId: this.uketsukeExtendsId
          })
          .then(
            (res: any) => {
              this.autoSave(0);
              this.loadingService.hide();
              if (isConfirm == 1) {
                this.confirm(isConfirmCopied);
              }
              this.$emit("closeNext");
            },
            (error: any) => {
              this.loadingService.hide();
              this.$notify.error({
                title: "エラー",
                message: MESSAGE.SystemError
              });
              this.$emit("closeNext");
            }
          );
      } else {
        this.autoSave(0);
        this.confirm(isConfirmCopied);
        this.$emit("closeNext");
      }
    }
  }

  onChangeCoupon(option?: any) {
    this.autoSave(1);
    this.onCheckChange(option);
  }
}
